import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Legacy standalone domains: carry the full path over to the monolith
if (/(^|\.)hellomortgagerenewal\.ca$/i.test(window.location.hostname)) {
  const path = window.location.pathname.replace(/^\/+/, "");
  window.location.replace(`https://www.hellomortgage.ca/renewal-checker/${path}${window.location.search}`);
}
if (/(^|\.)hellomortgageoptions\.ca$/i.test(window.location.hostname) || /\.emergent\.host$/i.test(window.location.hostname)) {
  // platform host is a duplicate of the live site — one canonical host only
  window.location.replace(`https://www.hellomortgage.ca${window.location.pathname}${window.location.search}${window.location.hash}`);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
